export const objectToBase64 = (obj: Record<string, any>) =>
  btoa(encodeURIComponent(JSON.stringify(obj)));
export const base64ToObject = (base64: string) => JSON.parse(decodeURIComponent(atob(base64)));
